export interface IRecipientFinancialInfo {
    primaryGroup: number
    primaryDetails: string
    secondaryGroup: number
    secondaryDetails: string
    insuranceLastUpdated: string
    isMedicarePostTransplant: any
    medicareNumber: string
    globalCaseRate: boolean
    professionalCaseRate: boolean
    relationshipToSubscriber: string
    patientName: string
    policyIdNumber: string
    groupNumber: string
    benefitPhone: string
    precertificationPhone: string
    healthPlanName: string
    claimsMailingAddress: string
    subscriberName: string
    caseManagerName: string
    caseManagerPhone: string
    financialComments: string
    isPrimaryInsuranceLocked: boolean
    isSecondaryInsuranceLocked: boolean
    privInsGlobalEndDays: string
}

export interface IRecipientFinancialInfoPost {
    primaryGroup: number
    primaryDetails: string
    secondaryGroup: number
    secondaryDetails: string
    isMedicarePostTransplant: any
    medicareNumber: string
    globalCaseRate: boolean
    professionalCaseRate: boolean
    relationshipToSubscriber: string
    patientName: string
    policyIdNumber: string
    groupNumber: string
    benefitPhone: string
    precertificationPhone: string
    healthPlanName: string
    claimsMailingAddress: string
    subscriberName: string
    caseManagerName: string
    caseManagerPhone: string
    financialComments: string
    privInsGlobalEndDays: string
}